<template>
  <v-card class="overflow-hidden px-10 py-5" height="90vh">
    <v-row
      justify="center"
      align="center"
      class="fill-height"
    >
      <v-card-text>
        <v-btn
          icon
          color="black"
          @click="$emit('close')"
          style="position: absolute; top: 15px; right: 15px;"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <!-- <v-img
          contain
          src="@/assets/images/reseller/logo.png"
          max-height="250"
          max-width="250"
        ></v-img> -->

        <div
          class="display-2 blue-grey--text font-weight-black text--lighten-1 mb-5"
        >
          <img
            v-show="logo"
            :src="logo"
            width="175px"
            style="object-fit: contain"
          />
        </div>

        <h2 class="mb-4 blue-grey--text font-weight-bold text--lighten-1">
          {{ title }}
        </h2>

        <!-- content -->
        <div style="max-height: 300px; overflow-y: scroll;">
          <h3 v-if="subtitle" class="mb-4 blue-grey--text font-weight-bold text--lighten-1">
            {{ subtitle }}
          </h3>

          <slot></slot>
        </div>
      </v-card-text>

      <v-card-actions class="justify-center">
        <v-btn
          tile
          depressed
          large
          color="#9faebc"
          dark
          width="30%"
          @click="$emit('close')"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-row>
  </v-card>
</template>

<script>
  export default {
    name: 'DialogCardLayout',

    props: {
      title: { type: String, default: '' },
      subtitle: { type: String, default: '' },
      logo: { type: String, default: null }
    }
  }
</script>

<style lang="scss" scoped>

</style>